import SalesChannelServ from '@api/SalesChannels/SalesChannelServ';
import { SalesChannel } from '@api/SalesChannels/SalesChannel';

class SalesChannelsService {
    saveSalesChannel = (salesChannel: SalesChannel): Promise<SalesChannel> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await SalesChannelServ.saveSalesChannel(salesChannel);
                resolve(data);
            } catch (error) {
                reject('Error saving sales channel: ' + error);
            }
        });
    };
    getSalesChannels = (): Promise<SalesChannel[]> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await SalesChannelServ.getSalesChannels();
                resolve(data);
            } catch (error) {
                reject('Error getting sales channels: ' + error);
            }
        });
    };
    getSalesChannel = (salesChannelId: string): Promise<SalesChannel> => {
        return new Promise(async (resolve, reject) => {
            try {
                const salesChannel = await SalesChannelServ.getSalesChannel(salesChannelId);
                resolve(salesChannel);
            } catch (error) {
                reject('Error getting sales channel: ' + error);
            }
        });
    };

    deleteSalesChannel = (salesChannelId: string): Promise<void> => {
        return new Promise(async (resolve, reject) => {
            try {
                await SalesChannelServ.deleteSalesChannel(salesChannelId);
                resolve();
            } catch (error) {
                reject('Error deleting sales channel: ' + error);
            }
        });
    };
}
export default SalesChannelsService;
